module.exports = __webpack_public_path__ + "img/cuff_button_diameter.6c9da6ca.png";